module.exports = __webpack_public_path__ + "static/media/lingshou.7902bceb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/lingshou.svg
// module id = 35
// module chunks = 6